import React from 'react'
import { Link } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import FormSF from '../../../widgets/form/FormSF'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import CreditAssessmentDateModalSF from '../clientData/CreditAssessmentDateModalSF'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'

const DataCollectionUI = ({ context, loan, onRefreshClick, onCopyToClipboard, copyToClipboardText,
  onNPSubmit, npSubmitted, npSuccessMsg, npErrorList, setNPErrorList, npFileList,
  onSMSubmit, smSubmitted, smSuccessMsg, smErrorList, setSMErrorList,
  onMCASubmit, mcaSubmitted, mcaSuccessMsg, mcaErrorList, setMCAErrorList, mcaFileList,
  onBSSubmit, bsSubmitted, bsSuccessMsg, bsErrorList, bsFileList,
  onITRSubmit, itrSubmitted, itrSuccessMsg, itrErrorList, itrFileList,
  onGSTSubmit, gstSubmitted, gstSuccessMsg, gstErrorList, gstFileList,
  updateDateMode, onUpdateDateClick, onCancelDateClick, onAccountUpdate,
  onDownloadFileClick, fileErrorList, onSkipCollectionGST, onSkipCollectionITR, skipCollectionModeGST, skipCollectionModeITR,
  itrSkippedSuccessMsg, itrSkippedErrorList, gstSkippedSuccessMsg, gstSkippedErrorList, selectedSkipCollectionGST,
  bsUploadMode, onBSUploadClick, onBSCancelUploadClick, bsSignedUrlApi, onBSUpload, bsUploadErrorList, onDeleteClick
}) =>
  <div>
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Financial data collection</b></span>
        </span>
      }
      right={<span />}
    />

    <div className='g_muted'>
      <span className='g_muted'>Account Id: {loan.account.accountId}</span>
      <CopyToClipboard text={loan.account.accountId}
        onCopy={onCopyToClipboard}>
        <span className='g_m_left_50 icon icon-clone g_cursor_pointer' />
      </CopyToClipboard>
      {
        copyToClipboardText === loan.account.accountId &&
        <span className='g_m_left_50'>copied</span>
      }
    </div>

    <MCADataCollection
      context={context}
      account={loan.account}
      onMCASubmit={onMCASubmit}
      mcaSubmitted={mcaSubmitted}
      mcaSuccessMsg={mcaSuccessMsg}
      mcaErrorList={mcaErrorList}
      setMCAErrorList={setMCAErrorList}
      mcaFileList={mcaFileList}
      onDownloadFileClick={onDownloadFileClick}
      fileErrorList={fileErrorList}
    />

    <GSTDataCollection
      context={context}
      account={loan.account}
      onGSTSubmit={onGSTSubmit}
      gstSubmitted={gstSubmitted}
      gstSuccessMsg={gstSuccessMsg}
      gstErrorList={gstErrorList}
      gstFileList={gstFileList}
      onSkipCollectionGST={onSkipCollectionGST}
      skipCollectionModeGST={skipCollectionModeGST}
      gstSkippedSuccessMsg={gstSkippedSuccessMsg}
      gstSkippedErrorList={gstSkippedErrorList}
      selectedSkipCollectionGST={selectedSkipCollectionGST}
      onDownloadFileClick={onDownloadFileClick}
      fileErrorList={fileErrorList}
    />

    <ITRDataCollection
      context={context}
      account={loan.account}
      onITRSubmit={onITRSubmit}
      itrSubmitted={itrSubmitted}
      itrSuccessMsg={itrSuccessMsg}
      itrErrorList={itrErrorList}
      itrFileList={itrFileList}
      onSkipCollectionITR={onSkipCollectionITR}
      skipCollectionModeITR={skipCollectionModeITR}
      itrSkippedSuccessMsg={itrSkippedSuccessMsg}
      itrSkippedErrorList={itrSkippedErrorList}
      onDownloadFileClick={onDownloadFileClick}
      fileErrorList={fileErrorList}
    />

    <BankStatmentCollection
      context={context}
      account={loan.account}
      onBSSubmit={onBSSubmit}
      bsSubmitted={bsSubmitted}
      bsSuccessMsg={bsSuccessMsg}
      bsErrorList={bsErrorList}
      bsFileList={bsFileList}
      bsUploadMode={bsUploadMode}
      onBSCancelUploadClick={onBSCancelUploadClick}
      bsSignedUrlApi={bsSignedUrlApi}
      onBSUpload={onBSUpload}
      bsUploadErrorList={bsUploadErrorList}
      onBSUploadClick={onBSUploadClick}
      onDownloadFileClick={onDownloadFileClick}
      fileErrorList={fileErrorList}
      onDeleteClick={onDeleteClick}
    />

    <DocumentUpload
      context={context}
      account={loan.account}
      //
      npErrorList={npErrorList}
      npSuccessMsg={npSuccessMsg}
      onNPSubmit={onNPSubmit}
      npSubmitted={npSubmitted}
      setNPErrorList={setNPErrorList}
      npFileList={npFileList}
      //
      smErrorList={smErrorList}
      smSuccessMsg={smSuccessMsg}
      onSMSubmit={onSMSubmit}
      smSubmitted={smSubmitted}
      setSMErrorList={setSMErrorList}
      //
      updateDateMode={updateDateMode}
      onAccountUpdate={onAccountUpdate}
      onUpdateDateClick={onUpdateDateClick}
      onCancelDateClick={onCancelDateClick}
      onCopyToClipboard={onCopyToClipboard}
      copyToClipboardText={copyToClipboardText}
      //
      onDownloadFileClick={onDownloadFileClick}
      fileErrorList={fileErrorList}
    />
  </div>

const DocumentUpload = ({ context, account,
  onNPSubmit, npSubmitted, npSuccessMsg, npErrorList, setNPErrorList, npFileList,
  onSMSubmit, smSubmitted, smSuccessMsg, smErrorList, setSMErrorList,
  updateDateMode, onUpdateDateClick, onCancelDateClick, onAccountUpdate,
  onCopyToClipboard, copyToClipboardText, onDownloadFileClick, fileErrorList
}) =>
  <CardUI title='Novel Patterns credit assessment' className='g_m_top_100'>
    <div className='g_flex_h g_flex_top'>
      <div>
        <div>
          {
            npFileList != null && npFileList.map((item) =>
              <span key={item}><Link className='g_m_right_50' onClick={onDownloadFileClick} to='#' data-type='np' data-file-name={item}>
                {item}
              </Link><br></br></span>)
          }
          {
            fileErrorList && fileErrorList.length > 0 &&
            <span>{fileErrorList[0].message}</span>
          }
        </div>
        <div>
          {
            account.documentStatus.creditAssessmentDocId &&
            <span className='g_m_right_100'>Doc Id: {account.documentStatus.creditAssessmentDocId}</span>
          }
          {
            account.documentStatus.npCAStatus === 'collected' &&
            <Link to={`/su/accounts/${account.accountId}/scoreParams`} onClick={() => window.scrollTo(0, 0)}>
              View
            </Link>
          }
        </div>
      </div>
      <div className='g_flex_v g_text_right'>
        <span><BadgeUI label={account.documentStatus.npCAStatus} /></span>
        <span className='g_muted'>{account.documentStatus.npStatusDateF1}</span>
      </div>
    </div>

    <div className='g_flex_h g_flex_top g_m_top_50'>
      <span className='g_muted'>Share documents with Novel Patterns for credit assessments:</span>
      <FormSF context={context} buttonLabel='Share with Novel Patterns'
        onSubmit={onNPSubmit} busy={npSubmitted} inlineButton={true}
        successMsg={npSuccessMsg} errorList={npErrorList} setErrorList={setNPErrorList}
      />
    </div>

    <div className='g_flex_h g_flex_left g_m_top_50'>
      Credit assessment date
      <span className='g_muted g_m_left_50'>{account.documentStatus.creditAssessmentDateF1}</span>
      <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onUpdateDateClick} />
    </div>

    <CreditAssessmentDateModalSF context={context} account={account}
      updateMode={updateDateMode} onCancelClick={onCancelDateClick} onAccountUpdate={onAccountUpdate}
    />
  </CardUI>

const MCADataCollection = ({ context, account,
  onMCASubmit, mcaSubmitted, mcaSuccessMsg, mcaErrorList, setMCAErrorList, mcaFileList,
  onDownloadFileClick, fileErrorList
}) =>
  <CardUI title='MCA data collection' className='g_m_top_50'>
    <div className='g_flex_h g_flex_top'>
      <div className='g_flex_v'>
        {
          account.documentStatus.mcaReferenceId &&
          <span className='g_muted'>Ref id: {account.documentStatus.mcaReferenceId}</span>
        }
        {
          <>
            {
              mcaFileList != null && mcaFileList.map((item) =>
                <Link className='g_m_right_50' onClick={onDownloadFileClick} to='#' data-type='mca' data-file-name={item}>
                  {item}
                </Link>)
              //<span>{item}<br></br></span>)
            }
            {
              fileErrorList && fileErrorList.length > 0 &&
              <span>{fileErrorList[0].message}</span>
            }
          </>
        }
      </div>
      <div className='g_flex_v g_text_right'>
        <span><BadgeUI label={account.documentStatus.mcaReceiveStatus} /></span>
        {
          account.documentStatus.mcaReceiveStatus !== 'not_initiated' &&
          <span className='g_muted'>{account.documentStatus.mcaStatusDateF1}</span>
        }
      </div>
    </div>

    <div className='g_flex_h g_m_top_50'>
      <span className='g_muted'>
        MCA data is collected automatically upon KYC.<br />
        It can also be intiated manually by clicking the button.<br />
        If company does not have CIN, then MCA data is not available.
      </span>
      <span className='g_text_right'>
        <FormSF context={context} buttonLabel='Initiate MCA Data Collection'
          onSubmit={onMCASubmit} busy={mcaSubmitted} inlineButton={true}
          successMsg={mcaSuccessMsg} errorList={mcaErrorList} setErrorList={setMCAErrorList}
        />
      </span>
    </div>
  </CardUI>

const GSTDataCollection = ({ context, account,
  onGSTSubmit, gstSubmitted, gstSuccessMsg, gstErrorList, gstFileList,
  onSkipCollectionGST, skipCollectionModeGST,
  gstSkippedSuccessMsg, gstSkippedErrorList, selectedSkipCollectionGST,
  onDownloadFileClick, fileErrorList
}) =>
  <CardUI title='GST data collection' className='g_m_top_100'>
    {
      fileErrorList && fileErrorList.length > 0 &&
      <span>{fileErrorList[0].message}</span>
    }
    {
      account.gstList.length === 0 &&
      <span>No GST</span>
    }
    {
      account.gstList.map((gst, i) =>
        <React.Fragment key={i}>
          <div className='g_flex_h g_flex_top'>
            <div className='g_flex_v'>
              <span>{gst.gstin}<br />{gst.registrationDateF1} @ {gst.state}</span>
              {
                gstFileList != null && gstFileList.filter(f => f.includes(gst.gstin)).map((item) =>
                  <Link className='g_m_right_50' onClick={onDownloadFileClick} to='#' data-type='gst' data-file-name={item}>
                    {item}
                  </Link>
                )
              }
              <span>{gst.failReason}</span>
            </div>
            <div className='g_flex_v g_text_right'>
              <span className='g_text_right'><BadgeUI label={gst.receiveStatus} /></span>
              {
                gst.receiveStatus !== 'not_initiated' &&
                <span className='g_m_left_50 g_muted'>{gst.statusDateF1}</span>
              }
            </div>
          </div>
          {
            context.permissions.includes('su_manage') && gst.receiveStatus !== 'collected' &&
            <div className='g_flex_h g_m_top_50'>
              <span className='g_muted'>If GST data is not available, skip GST collection</span>
              <div className='g_text_right'>
                <div className='g_flex_h g_flex_right'>
                  <ButtonTinyUI label='Skip Collection' rowId={gst.gstin} onClick={onSkipCollectionGST} />
                  <SpinnerUI className='g_m_left_50' show={skipCollectionModeGST && gst.gstin === selectedSkipCollectionGST} />
                </div>
                {
                  gst.gstin === selectedSkipCollectionGST && <span>{gstSkippedSuccessMsg}</span>
                }
              </div>
            </div>
          }
        </React.Fragment>
      )
    }
    {
      account.gstList.length > 0 && account.gstList[0].receiveStatus !== 'not_initiated' &&
      context.permissions.includes('su_manage') &&
      <div className='g_flex_h g_flex_top g_m_top_50'>
        <span className='g_muted'>If GST data needs to be collected again, click the button:</span>
        <FormSF context={context} buttonLabel='Enable Collection of GST Data'
          onSubmit={onGSTSubmit} busy={gstSubmitted}
          successMsg={gstSuccessMsg} errorList={gstErrorList}
          inlineButton={true}
        />
      </div>
    }
  </CardUI>

const ITRDataCollection = ({ context, account,
  onITRSubmit, itrSubmitted, itrSuccessMsg, itrErrorList, itrFileList,
  onSkipCollectionITR, skipCollectionModeITR,
  itrSkippedSuccessMsg, itrSkippedErrorList,
  onDownloadFileClick, fileErrorList
}) =>
  <CardUI title='ITR data collection' className='g_m_top_100'>
    <div className='g_flex_h g_flex_top'>
      <div className='g_flex_v'>
        {
          account.documentStatus.itrReferenceId &&
          <span className='g_muted'>Ref id: {account.documentStatus.itrReferenceId}</span>
        }
        {
          // account.documentStatus.itrReceiveStatus === 'collected' &&
          <>
            {
              itrFileList != null && itrFileList.map((item) =>
                <Link className='g_m_right_50' onClick={onDownloadFileClick} to='#' data-type='itr' data-file-name={item}>
                  {item}
                </Link>)
              //<span>{item}<br></br></span>)
            }
            {
              fileErrorList && fileErrorList.length > 0 &&
              <span>{fileErrorList[0].message}</span>
            }
          </>
        }
      </div>
      <div className='g_flex_v g_text_right'>
        <span><BadgeUI label={account.documentStatus.itrReceiveStatus} /></span>
        {
          account.documentStatus.itrReceiveStatus !== 'not_initiated' &&
          <span className='g_muted'>{account.documentStatus.itrStatusDateF1}</span>
        }
      </div>
    </div>

    {
      account.documentStatus.itrReceiveStatus === 'collected' &&
      context.permissions.includes('su_manage') &&
      <div className='g_flex_h g_flex_top g_m_top_50'>
        <span className='g_muted'>If ITR data needs to be collected again, click the button:</span>
        <FormSF context={context} buttonLabel='Enable Collection of ITR Data'
          onSubmit={onITRSubmit} busy={itrSubmitted}
          successMsg={itrSuccessMsg} errorList={itrErrorList}
          inlineButton={true}
        />
      </div>
    }
    {
      context.permissions.includes('su_manage') && account.documentStatus.itrReceiveStatus !== 'collected' &&
      <div className='g_flex_h g_m_top_50'>
        <span className='g_muted'>If ITR data is not available, skip ITR collection</span>
        <div className='g_flex_h g_flex_right g_text_right'>
          <ButtonTinyUI label='Skip collection' onClick={onSkipCollectionITR} />
          <SpinnerUI className='g_m_left_50' show={skipCollectionModeITR} />
        </div>
      </div>
    }
    <span>{itrSkippedSuccessMsg}</span>
  </CardUI>

const BankStatmentCollection = ({ context, account,
  onBSSubmit, bsSubmitted, bsSuccessMsg, bsErrorList, bsFileList,
  onDownloadFileClick, fileErrorList, onDeleteClick,
  bsUploadMode, onBSUploadClick, onBSCancelUploadClick, bsSignedUrlApi, onBSUpload, bsUploadErrorList
}) =>
  <CardUI title='Bank statements collection' className='g_m_top_100'>
    <div className='g_flex_h g_flex_top'>
      <div className='g_flex_h'>
        <div>
          {
            bsFileList != null && bsFileList.map((item) =>
              <span className='g_flex_h g_flex_left' key={item}>
                <Link className='g_m_right_50' onClick={onDownloadFileClick} to='#' data-type='bs' data-file-name={item}>
                  {item}
                </Link>
                {
                  context.permissions.includes('su_manage') &&
                  <span className='icon icon-trash-o g_m_left_25 g_cursor_pointer g_muted' onClick={onDeleteClick}
                    data-file-name={item}>
                  </span>
                }
              </span>
            )
          }
          {
            fileErrorList && fileErrorList.length > 0 &&
            <span>{fileErrorList[0].message}</span>
          }
        </div>
      </div>
      <div className='g_flex_v g_text_right'>
        <span><BadgeUI label={account.documentStatus.bankStatementReceiveStatus} /></span>
        {
          account.documentStatus.bankStatementReceiveStatus !== 'not_initiated' &&
          <>
            <span className='g_muted'>
              {account.documentStatus.bankStatementStatusDateF1}<br/>
              {bsFileList && bsFileList.length} files
            </span>
          </>
        }
      </div>
    </div>

    <div className='g_flex_h g_flex_top g_m_top_50'>
      <span className='g_muted'>Upload a pdf, or a zip file (without folders) containing bank statements:</span>
      <ButtonTinyWithSpinnerUI label='Upload Bank Statements' onClick={onBSUploadClick}
        alignLeft={false} errorList={bsUploadErrorList}
      />
    </div>

    {
      account.documentStatus.bankStatementReceiveStatus === 'collected' &&
      <div className='g_flex_h g_flex_top g_m_top_50'>
        <span className='g_muted'>If borrower needs to re-upload bank statements again, click the button:</span>
        <FormSF context={context} buttonLabel='Delete All and Enable Re-upload'
          onSubmit={onBSSubmit} busy={bsSubmitted}
          successMsg={bsSuccessMsg} errorList={bsErrorList}
          inlineButton={true}
        />
      </div>
    }

    <FileUploadModalSF
      context={context}
      uploadMode={bsUploadMode}
      onCancelClick={onBSCancelUploadClick}
      signedUrlApi={bsSignedUrlApi}
      onUpload={onBSUpload}
    />

  </CardUI>

export default DataCollectionUI
